import PropTypes from 'prop-types';
import { createContext, useContext } from 'react';

import { useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { parksRegionNameSelector } from '../../redux/park/derivedSelectors';
import { useFetchData } from '../Content/TravelHooks/useFetchData';
import { useGetTravelGuideData } from '../HolidayPark/useGetTravelGuideData';

const ThingsToDoContext = createContext();

export const ThingsToDoProvider = ({ children }) => {
  const { regionName: slugifiedRegionName } = useParams();

  const parksRegionName = useSelector(parksRegionNameSelector);

  const location = useLocation();
  const isTravelGuidePage = location.pathname.includes('travel-guide');

  const regionName = isTravelGuidePage ? slugifiedRegionName : parksRegionName;

  const { ttdData } = useGetTravelGuideData(regionName);
  const posts = useFetchData(ttdData, 'things-to-do');

  const postsData = ttdData.length > 0 ? posts : [];

  return <ThingsToDoContext.Provider value={{ postsData }}>{children}</ThingsToDoContext.Provider>;
};

export const useThingsToDoContext = () => useContext(ThingsToDoContext);

ThingsToDoProvider.propTypes = {
  children: PropTypes.node,
};
